import React, { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }: any): ReactElement => {
  const token = localStorage.getItem('@LiveChat:token');
  let auth = false;

  if (token) {
    auth = true;
  }

  return auth ? children : <Navigate to="/" />;
};

export default PrivateRoute;
